// src/types/booking-rules/CheckoutAvailability.ts
var CheckoutReasonCode = /* @__PURE__ */ ((CheckoutReasonCode2) => {
  CheckoutReasonCode2["MinStay"] = "min_stay";
  CheckoutReasonCode2["MaxStay"] = "max_stay";
  CheckoutReasonCode2["DisallowCheckoutDay"] = "disallow_checkout_day";
  CheckoutReasonCode2["Rejected"] = "rejected";
  CheckoutReasonCode2["IdentityNotVerified"] = "identity_not_verified";
  CheckoutReasonCode2["IdentityVerificationPending"] = "identity_verification_pending";
  CheckoutReasonCode2["IdentityVerificationRejected"] = "identity_verification_rejected";
  CheckoutReasonCode2["ExternalPricingUnavailable"] = "external_pricing_unavailable";
  CheckoutReasonCode2["ExternalPricingRecalibrating"] = "external_pricing_recalibrating";
  CheckoutReasonCode2["Closed"] = "closed";
  CheckoutReasonCode2["ClosedToArrival"] = "closed_to_arrival";
  CheckoutReasonCode2["ClosedToDeparture"] = "closed_to_departure";
  return CheckoutReasonCode2;
})(CheckoutReasonCode || {});

export {
  CheckoutReasonCode
};
